import { createStore } from 'vuex'
import auth from './auth'
import layout from './layout'
import trackPlayer from './track-player'
import editor from './editor'

export default createStore({
  modules: { auth, layout, trackPlayer, editor }
})
